export default "__VITE_ASSET__2812f92b__"